export default __webpack_public_path__ + "static/media/element_33.48f207e3.webp";